import React from "react";
import { Controller } from "react-hook-form";

import { IDealerRowProps } from "./types";

interface IHiddenDealerControllersProps extends IDealerRowProps {
  index: number;
  positionNumber: string;
}

const HiddenDealerControllers = ({
  index,
  positionNumber,
  control,
  dealerPrefix,
}: IHiddenDealerControllersProps) => (
  <>
    <Controller
      name={`positions.${index}.number`}
      control={control}
      defaultValue={positionNumber}
      render={() => null}
    />
    <Controller
      name={`${dealerPrefix}.employeePositionId`}
      control={control}
      render={() => null}
    />
    <Controller
      name={`${dealerPrefix}.dismissalOrder`}
      control={control}
      render={() => null}
    />
    <Controller
      name={`${dealerPrefix}.jobDescription`}
      control={control}
      render={() => null}
    />
    <Controller
      name={`${dealerPrefix}.status`}
      control={control}
      render={() => null}
    />
    <Controller
      name={`${dealerPrefix}.dataConsent`}
      control={control}
      render={() => null}
    />
    <Controller
      name={`positions.${index}.licenseAssigned`}
      control={control}
      render={() => null}
    />
    <Controller
      name={`positions.${index}.licenseFreeCount`}
      control={control}
      render={() => null}
    />
  </>
);

export default HiddenDealerControllers;
